export default "__VITE_ASSET__C$mWbNcw__"